
    window.addEventListener('load', (event) => {
        setInitialTable();
    });
    function setInitialTable(e) {
        let value = !window.location.hash ? "acacia-jar" : window.location.hash.substring(1);
        
        document.getElementById("selected-product-type").value = value;

        onSelectedProductTypeChange({ value: value })
    }

    function onSelectedProductTypeChange(e) {
        if (!e)
            return;

        let value = e.value;

        switch (value) {
            default: {
                document.getElementById("acacia-bear-rules").classList.add("d-none");
                document.getElementById("candies-rules").classList.add("d-none");
                document.getElementById("choccolates-rules").classList.add("d-none");
                document.getElementById("propolis-rules").classList.add("d-none");

                document.getElementById("jar-rules").classList.remove("d-none");
                break;
            }
            case "wildflower-jar":
            case "honeydew-jar":
            case "chestnut-jar":
            case "acacia-jar":
            case "pollen-jar": {
                document.getElementById("acacia-bear-rules").classList.add("d-none");
                document.getElementById("candies-rules").classList.add("d-none");
                document.getElementById("choccolates-rules").classList.add("d-none");
                document.getElementById("propolis-rules").classList.add("d-none");

                document.getElementById("jar-rules").classList.remove("d-none");
                break;
            }
            case "acacia-bear": {
                document.getElementById("jar-rules").classList.add("d-none");
                document.getElementById("candies-rules").classList.add("d-none");
                document.getElementById("choccolates-rules").classList.add("d-none");
                document.getElementById("propolis-rules").classList.add("d-none");

                document.getElementById("acacia-bear-rules").classList.remove("d-none");
                break;
            }
            case "candies": {
                document.getElementById("jar-rules").classList.add("d-none");
                document.getElementById("acacia-bear-rules").classList.add("d-none");
                document.getElementById("choccolates-rules").classList.add("d-none");
                document.getElementById("propolis-rules").classList.add("d-none");

                document.getElementById("candies-rules").classList.remove("d-none");
                break;
            }
            case "choccolates": {
                document.getElementById("jar-rules").classList.add("d-none");
                document.getElementById("acacia-bear-rules").classList.add("d-none");
                document.getElementById("candies-rules").classList.add("d-none");
                document.getElementById("propolis-rules").classList.add("d-none");

                document.getElementById("choccolates-rules").classList.remove("d-none");
                break;
            }
            case "propolis": {
                document.getElementById("jar-rules").classList.add("d-none");
                document.getElementById("acacia-bear-rules").classList.add("d-none");
                document.getElementById("candies-rules").classList.add("d-none");
                document.getElementById("choccolates-rules").classList.add("d-none");

                document.getElementById("propolis-rules").classList.remove("d-none");
                break;
            }
        }
    
        window.location.hash = "#" + value;
    }
